import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import {
  formatMetric,
  getEngagementMetrics,
  hasSyncedEngagement,
  isPublishedPost,
  unavailableMetricsLabel,
} from './postUtils';
import { StatusChip } from '../../components/primitives';

export function PublishStatusChip({ post, labelPrefix = '' }) {
  return <StatusChip post={post} labelPrefix={labelPrefix} />;
}

export function EngagementSummary({ post, compact = false }) {
  const metrics = getEngagementMetrics(post);

  if (!isPublishedPost(post)) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  if (metrics.unavailable) {
    return (
      <Typography variant="body2" color="text.secondary">
        {unavailableMetricsLabel(metrics)}
      </Typography>
    );
  }

  if (!hasSyncedEngagement(post)) {
    return <StatusChip status="pending_sync" />;
  }

  const items = [
    ['Likes', metrics.likes],
    ['Comments', metrics.comments],
    ['Shares', metrics.shares],
    ['Reach', metrics.reach],
  ];

  if (compact) {
    return (
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {items.map(([label, value]) => (
          <Typography key={label} variant="caption" color="text.secondary">
            {label}: {formatMetric(value)}
          </Typography>
        ))}
      </Box>
    );
  }

  return (
    <Grid container spacing={1}>
      {items.map(([label, value]) => (
        <Grid item xs={6} sm={3} key={label}>
          <Paper variant="outlined" sx={{ p: 1, textAlign: 'center' }}>
            <Typography variant="caption" color="text.secondary" display="block">
              {label}
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {formatMetric(value)}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}
